import Action from 'redux/helpers/createAction'
const name = 'notification'

export const getNotificationOverview = Action(
  name + '/GET_NOTIFICATION_DATA',
  (domainId, filters) => ({
    domainId,
    filters
  })
)

export const getNotificationOverviewSuccess = Action(
  name + '/GET_NOTIFICATION_DATA_SUCCESS',
  data => ({
    data
  })
)

export const getNotificationOverviewFailure = Action(
  name + '/GET_NOTIFICATION_DATA_FAILURE',
  error => ({
    error
  })
)

export const exportDomainKeywordNotificationsExcel = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_NOTIFICATIONS_DATA_EXCEL',
  domainId => ({
    domainId
  })
)

export const exportDomainKeywordNotificationsCSV = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_NOTIFICATIONS_DATA_CSV',
  domainId => ({
    domainId
  })
)
